/* AccessReport.js — گزارش «کی به چی دسترسی دارد»
   دو حالت: بر اساس کاربر، یا بر اساس فرم/کلید.
   ارث‌بری گروه و سطح FullAccess/FullView لحاظ شده، پس نتیجه همان چیزی است
   که کاربر واقعاً در برنامه می‌بیند — نه صرفاً سطرهای خام tblPermission.
*/
import React, { useState, useEffect, useCallback } from 'react';
import { TabBar } from '../TabManager';
import useColumnResize from '../../hooks/useColumnResize';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const API  = (path,opts={}) => fetch(`/api/system${path}`,{
  headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts,
}).then(r=>r.json());

const MODES = [
  {val:'user', label:'بر اساس کاربر'},
  {val:'form', label:'بر اساس فرم یا کلید'},
];

const INIT_WIDTHS   = [45,230,150,140,110,100,100,100,100,240];
const INIT_WIDTHS_F = [45,230,160,140,120,200];

export default function AccessReport({ user, onBack }) {
  const [mode,setMode]       = useState('user');
  const [rows,setRows]       = useState([]);
  const [loading,setLoading] = useState(false);
  const [includeGroups,setIncludeGroups] = useState(true);
  const [search,setSearch]   = useState('');
  const [detail,setDetail]   = useState(null);

  /* حالت فرم */
  const [formName,setFormName]   = useState('');
  const [controlName,setControlName] = useState('');

  const {TH}  = useColumnResize(INIT_WIDTHS);
  const {TH:THF} = useColumnResize(INIT_WIDTHS_F);

  const fetchUsers = useCallback(async()=>{
    setLoading(true);
    const d = await API(`/access-report/?by=user&include_groups=${includeGroups?1:0}`);
    if(d.ok) setRows(d.rows); else alert(d.error||'خطا');
    setLoading(false);
  },[includeGroups]);

  useEffect(()=>{ if(mode==='user') fetchUsers(); },[mode,includeGroups]); // eslint-disable-line

  const fetchByForm = async()=>{
    if(!formName.trim()){ alert('نام فرم یا صفحه را وارد کنید'); return; }
    setLoading(true);
    const q = new URLSearchParams({by:'form',form_name:formName.trim(),
      control_name:controlName.trim(),include_groups:includeGroups?'1':'0'}).toString();
    const d = await API(`/access-report/?${q}`);
    if(d.ok) setRows(d.rows); else alert(d.error||'خطا');
    setLoading(false);
  };

  const filtered = rows.filter(r=>{
    if(!search.trim()) return true;
    const q = search.trim();
    return [r.people_name,r.username,r.group_name].join(' ').includes(q);
  });

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="" style={{width:'34px',height:'34px',borderRadius:'7px'}}/></div>
          <div><div style={s.hTitle}>گزارش دسترسی‌ها</div><div style={s.hSub}>بخش سیستم</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>

      <main style={s.main}>
        <div style={s.toolbar}>
          <div style={{display:'flex',gap:'14px',alignItems:'center'}}>
            {MODES.map(m=>(
              <label key={m.val} style={s.radio}>
                <input type="radio" name="mode" checked={mode===m.val}
                  onChange={()=>{setMode(m.val);setRows([]);}}/><span>{m.label}</span></label>))}
          </div>
          <label style={s.radio}>
            <input type="checkbox" checked={includeGroups}
              onChange={e=>setIncludeGroups(e.target.checked)}/>
            <span>نمایش گروه‌های دسترسی</span></label>
          {mode==='user' &&
            <button onClick={fetchUsers} style={{...s.btnGo,marginRight:'auto'}}>↻ بازخوانی</button>}
        </div>

        {mode==='form' && (
          <div style={s.toolbar2}>
            <div>
              <div style={s.fL}>نام صفحه یا فرم (مثل TBDEPOSIT یا frmCreditNew)</div>
              <input value={formName} onChange={e=>setFormName(e.target.value)}
                placeholder="TBDEPOSIT" style={{...s.fI,width:'240px',direction:'ltr'}}/>
            </div>
            <div>
              <div style={s.fL}>نام کلید (اختیاری)</div>
              <input value={controlName} onChange={e=>setControlName(e.target.value)}
                placeholder="btnCreditNew" style={{...s.fI,width:'220px',direction:'ltr'}}/>
            </div>
            <button onClick={fetchByForm} style={s.btnGo}>🔍 جستجو</button>
            <div style={{marginRight:'auto',fontSize:'11px',color:'#888',maxWidth:'380px'}}>
              نام فنی هر فرم و کلید را می‌توانید از ستون «نام فنی» در صفحه سطوح دسترسی بردارید.
            </div>
          </div>)}

        <div style={s.toolbar2}>
          <div style={{marginRight:'auto'}}>
            <div style={s.fL}>جستجو در نتیجه</div>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="نام کاربر / نام کاربری / گروه" style={{...s.fI,width:'300px'}}/>
          </div>
        </div>

        <div style={s.tableWrap}>
          {mode==='user' ? (
            <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
              <thead style={{position:'sticky',top:0,zIndex:3}}>
                <tr>
                  <TH idx={0}>ردیف</TH>
                  <TH idx={1} right>نام کاربر / گروه</TH>
                  <TH idx={2}>نام کاربری</TH>
                  <TH idx={3}>سطح</TH>
                  <TH idx={4} gold>کل مجوز</TH>
                  <TH idx={5}>صفحه</TH>
                  <TH idx={6}>فرم</TH>
                  <TH idx={7}>کلید</TH>
                  <TH idx={8} red>درخواستی</TH>
                  <TH idx={9} right>عضو گروه‌های</TH>
                </tr>
              </thead>
              <tbody>
                {filtered.length===0 && (
                  <tr><td colSpan={10} style={s.empty}>
                    {loading?'در حال بارگذاری...':'اطلاعاتی برای نمایش وجود ندارد'}</td></tr>)}
                {filtered.map((r,idx)=>(
                  <tr key={r.user_id} onClick={()=>setDetail(r)}
                    style={{cursor:'pointer',
                      background:r.is_group?'#ede7f6':idx%2===0?'#fff':'#fdf6e3'}}
                    onMouseEnter={e=>{e.currentTarget.style.background='#bbdefb';}}
                    onMouseLeave={e=>{e.currentTarget.style.background=
                      r.is_group?'#ede7f6':idx%2===0?'#fff':'#fdf6e3';}}>
                    <td style={s.td}>{toFa(idx+1)}</td>
                    <td style={{...s.td,textAlign:'right'}}>
                      {r.is_group?<span style={{color:'#4a148c',fontWeight:'700'}}>👥 </span>:''}
                      {r.people_name||r.group_name}</td>
                    <td style={{...s.td,direction:'ltr'}}>{r.username}</td>
                    <td style={s.td}>{r.full_access
                      ? <span style={{color:'#b71c1c',fontWeight:'700'}}>دسترسی کامل</span>
                      : r.full_view
                      ? <span style={{color:'#e65100',fontWeight:'700'}}>فقط مشاهده</span>
                      : <span style={{color:'#666'}}>عادی</span>}</td>
                    <td style={{...s.td,fontWeight:'700',color:'#1565c0'}}>{toFa(r.total)}</td>
                    <td style={s.td}>{toFa(r.tab_count)}</td>
                    <td style={s.td}>{toFa(r.form_count)}</td>
                    <td style={s.td}>{toFa(r.button_count)}</td>
                    <td style={{...s.td,color:r.pending?'#e65100':'#ccc',fontWeight:'700'}}>
                      {r.pending?toFa(r.pending):''}</td>
                    <td style={{...s.td,textAlign:'right'}} title={r.groups.join('، ')}>
                      {r.groups.join('، ')}</td>
                  </tr>))}
              </tbody>
            </table>
          ) : (
            <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
              <thead style={{position:'sticky',top:0,zIndex:3}}>
                <tr>
                  <THF idx={0}>ردیف</THF>
                  <THF idx={1} right>نام کاربر / گروه</THF>
                  <THF idx={2}>نام کاربری</THF>
                  <THF idx={3}>نوع</THF>
                  <THF idx={4}>—</THF>
                  <THF idx={5} right>منشأ دسترسی</THF>
                </tr>
              </thead>
              <tbody>
                {filtered.length===0 && (
                  <tr><td colSpan={6} style={s.empty}>
                    {loading?'در حال بارگذاری...':'کسی به این مورد دسترسی ندارد یا هنوز جستجو نکرده‌اید'}
                  </td></tr>)}
                {filtered.map((r,idx)=>(
                  <tr key={r.user_id} style={{background:r.is_group?'#ede7f6'
                    :idx%2===0?'#fff':'#fdf6e3'}}>
                    <td style={s.td}>{toFa(idx+1)}</td>
                    <td style={{...s.td,textAlign:'right'}}>{r.people_name||r.group_name}</td>
                    <td style={{...s.td,direction:'ltr'}}>{r.username}</td>
                    <td style={s.td}>{r.is_group?'گروه':'کاربر'}</td>
                    <td style={s.td}></td>
                    <td style={{...s.td,textAlign:'right'}}>{r.source}</td>
                  </tr>))}
              </tbody>
            </table>
          )}
        </div>

        <div style={s.summary}>
          <span>تعداد: <b>{toFa(filtered.length)}</b></span>
          {mode==='user' && <span style={{color:'#888'}}>
            روی هر ردیف کلیک کنید تا صفحه‌های در دسترس آن کاربر را ببینید</span>}
          {mode==='form' && formName &&
            <span>دسترسی به: <b style={{direction:'ltr',display:'inline-block'}}>
              {formName}{controlName?`.${controlName}`:''}</b></span>}
        </div>
      </main>

      {/* جزئیات یک کاربر */}
      {detail && (
        <div style={s.overlay} onClick={()=>setDetail(null)}>
          <div style={{...s.modal,maxWidth:'640px'}} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}>
              <div style={s.mTitle}>
                🔐 {detail.people_name||detail.group_name} — {detail.access_title}
              </div>
              <button onClick={()=>setDetail(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={s.mBody}>
              <div style={s.infoRow}>
                <span>کل مجوزها: <b>{toFa(detail.total)}</b></span>
                <span>صفحه: <b>{toFa(detail.tab_count)}</b></span>
                <span>فرم: <b>{toFa(detail.form_count)}</b></span>
                <span>کلید: <b>{toFa(detail.button_count)}</b></span>
              </div>
              {detail.groups.length>0 && (
                <div style={s.groupBox}>
                  عضو گروه‌های دسترسی: <b>{detail.groups.join('، ')}</b>
                  <div style={{fontSize:'11px',marginTop:'4px'}}>
                    مجوزهای این گروه‌ها به کاربر ارث می‌رسد و در اعداد بالا لحاظ شده است.
                  </div>
                </div>)}
              <div style={{fontSize:'12px',fontWeight:'700',margin:'10px 0 6px',color:'#1a2f50'}}>
                صفحه‌های در دسترس
              </div>
              <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                {detail.tabs.length===0
                  ? <span style={{color:'#999',fontSize:'12px'}}>هیچ صفحه‌ای در دسترس نیست</span>
                  : detail.tabs.map(t=>(
                      <span key={t} style={s.chip}>{t}</span>))}
              </div>
              {detail.full_access===1 && (
                <div style={s.warnBox}>
                  این کاربر دسترسی کامل دارد: در هر صفحه‌ای که واردش شود، همه فرم‌ها و
                  کلیدها برایش باز است.
                </div>)}
              {detail.full_view===1 && (
                <div style={s.warnBox}>
                  این کاربر فقط مشاهده دارد: همه فرم‌ها را می‌بیند ولی کلیدهای
                  جدید، ویرایش، حذف و مانند آن برایش بسته است.
                </div>)}
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setDetail(null)} style={s.btnCancel}>بستن</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page:{height:'100vh',overflow:'hidden',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl',display:'flex',flexDirection:'column'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'10px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',flexShrink:0},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'8px 20px',flex:1,display:'flex',flexDirection:'column',overflow:'auto',minHeight:0},
  toolbar:{display:'flex',alignItems:'center',gap:'16px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolbar2:{display:'flex',alignItems:'flex-end',gap:'12px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  radio:{display:'flex',alignItems:'center',gap:'5px',fontSize:'12px',fontWeight:'600',color:'#444',cursor:'pointer'},
  fL:{fontSize:'11px',fontWeight:'600',color:'#555',marginBottom:'3px'},
  fI:{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box'},
  btnGo:{padding:'8px 18px',background:'linear-gradient(135deg,#4a148c,#6a1b9a)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  tableWrap:{overflowX:'auto',overflowY:'auto',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',background:'#fff',flex:1,minHeight:'260px'},
  td:{padding:'6px 8px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  empty:{textAlign:'center',padding:'40px',color:'#999',fontSize:'13px'},
  summary:{display:'flex',gap:'18px',flexWrap:'wrap',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',margin:'6px 0',fontSize:'12px',color:'#444',flexShrink:0},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:{background:'#fff',borderRadius:'16px',width:'100%',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'},
  mHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',gap:'10px',padding:'14px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',borderRadius:'16px 16px 0 0'},
  mTitle:{fontSize:'14px',fontWeight:'700',color:'#fff'},
  closeBtn:{background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'13px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0},
  mBody:{overflowY:'auto',flex:1,padding:'18px'},
  mFooter:{display:'flex',justifyContent:'flex-end',gap:'10px',padding:'12px 18px',borderTop:'1px solid #f0f2f7',background:'#f8f9fa',borderRadius:'0 0 16px 16px'},
  infoRow:{display:'flex',gap:'18px',flexWrap:'wrap',fontSize:'12px',color:'#444',background:'#fafafa',border:'1px solid #eee',borderRadius:'8px',padding:'10px 14px',marginBottom:'10px'},
  groupBox:{background:'#f3e5f5',border:'1px solid #ce93d8',borderRadius:'8px',padding:'9px 14px',color:'#4a148c',fontSize:'12px',marginBottom:'10px'},
  warnBox:{background:'#fff8e1',border:'1px solid #ffe082',borderRadius:'8px',padding:'9px 14px',color:'#e65100',fontSize:'12px',lineHeight:'1.9',marginTop:'12px'},
  chip:{background:'#e3f2fd',border:'1px solid #90caf9',borderRadius:'6px',padding:'4px 10px',fontSize:'11px',color:'#0d47a1',direction:'ltr',fontWeight:'700'},
  btnCancel:{padding:'8px 18px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
};
